import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const pains = [{
  title: 'Llegas cansado todos los días',
  desc: 'Sin energía ni motivación para entrenar.'
}, {
  title: 'Empiezas rutinas… y las abandonas',
  desc: 'La falta de constancia te hace volver siempre al mismo punto.'
}, {
  title: 'No tienes tiempo para ir al gimnasio',
  desc: 'Tu rutina diaria no te deja horas libres.'
}, {
  title: 'No sabes qué ejercicios hacer',
  desc: 'Pierdes tiempo buscando videos y consejos contradictorios.'
}, {
  title: 'Te sientes incómodo con tu cuerpo',
  desc: 'Tu confianza y autoestima disminuyen cada vez más.'
}, {
  title: 'Sientes que tu cuerpo empeora',
  desc: 'Menos energía, más cansancio y hábitos desordenados.'
}, {
  title: 'Siempre dices “empiezo el lunes”',
  desc: 'Pero nunca logras sostenerlo.'
}];
export function PainPoints() {
  return <section className="py-24 px-4 bg-black relative overflow-hidden" data-id="element-136">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand/5 rounded-full blur-[120px] pointer-events-none" data-id="element-137" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-139">
          <h2 className="text-5xl md:text-6xl font-display uppercase text-white mb-6" data-id="element-140">
            ¿TE PASA ESTO?
          </h2>
          <p className="text-xl text-gray-400" data-id="element-141">
            Si quieres cambiar tu cuerpo, probablemente esto te resulte
            familiar:
          </p>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-142">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-4 bg-dark-card/50 border border-dark-border p-6 rounded-xl hover:border-brand/30 transition-colors" data-id="element-143">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-144" />
              <div data-id="element-145">
                <h3 className="text-lg font-bold text-white mb-1" data-id="element-146">
                  {pain.title}
                </h3>
                <p className="text-gray-400" data-id="element-147">{pain.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-148">
          <h3 className="text-3xl md:text-5xl font-display uppercase text-brand text-glow" data-id="element-149">
            ¿CUÁNTO TIEMPO MÁS VAS A SEGUIR POSTERGANDO TU CAMBIO?
          </h3>
        </motion.div>
      </div>
    </section>;
}